function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.17 113.84C88.468 113.84 113.84 88.468 113.84 57.17C113.84 25.872 88.468 0.5 57.17 0.5C25.872 0.5 0.5 25.872 0.5 57.17C0.5 88.468 25.872 113.84 57.17 113.84Z",
  fill: "#D7F74F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.17 113.84C88.468 113.84 113.84 88.468 113.84 57.17C113.84 25.872 88.468 0.5 57.17 0.5C25.872 0.5 0.5 25.872 0.5 57.17C0.5 88.468 25.872 113.84 57.17 113.84Z",
  fill: "#D7F74F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.17 113.84C88.468 113.84 113.84 88.468 113.84 57.17C113.84 25.872 88.468 0.5 57.17 0.5C25.872 0.5 0.5 25.872 0.5 57.17C0.5 88.468 25.872 113.84 57.17 113.84Z",
  fill: "url(#paint1_radial_570_195)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M59.5001 14.8798C42.0501 9.0298 24.9401 16.9598 17.8501 34.2098C14.0901 43.3398 13.9501 54.3498 13.8101 64.9998C13.7001 73.2598 13.6001 81.0598 11.7701 86.5998C11.4301 87.6298 11.0601 88.6198 10.6801 89.5798C12.7801 92.5898 15.1701 95.3898 17.8001 97.9298C19.0501 95.4498 20.2101 92.7098 21.2001 89.7098C23.5101 82.7098 23.6201 74.1698 23.7301 65.1198C23.8601 55.3998 23.9901 45.3598 27.0201 37.9798C32.1001 25.6198 43.8501 20.1298 56.2901 24.2798C68.6801 28.5798 74.6401 40.0898 71.1401 52.9898C69.0501 60.6898 63.0201 68.7298 57.2001 76.5098C51.7801 83.7498 46.6601 90.5898 44.2201 97.5398C42.3001 103 42.5001 107.96 43.7001 112.23C46.6701 112.95 49.7301 113.45 52.8701 113.68C51.9801 110.01 51.9001 105.66 53.6001 100.83C55.5301 95.3198 60.2101 89.0698 65.1601 82.4598C71.5401 73.9398 78.1401 65.1198 80.7301 55.5898C85.6201 37.5898 76.8901 20.8798 59.5001 14.8698V14.8798Z",
  fill: "url(#paint2_radial_570_195)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(65.0472 113.911) rotate(-89.73) scale(8.2251 47.3119)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#7A7A7A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#7A7A7A",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#7A7A7A",
  stopOpacity: 0.63
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#7A7A7A",
  stopOpacity: 0.36
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#7A7A7A",
  stopOpacity: 0.16
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#7A7A7A",
  stopOpacity: 0.04
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94,
  stopColor: "#7A7A7A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(38.82 40.57) scale(87.92)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#D0ED1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#C7E51C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#B1D017"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#8DAD0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#5A7E01"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#567A00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(42.8901 33.6198) scale(74.27 74.27)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#FAFAFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EEEEF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#DADAED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D0D0E8"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(38.82 40.57) scale(87.92)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#FCFCFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3F3F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#E4E4E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#CECECE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7,
  stopColor: "#B3B3B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#919191"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#696969"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#3A3A3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#060606"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-3.24353 89.3101) rotate(-123.49) scale(14.4656 36.164)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#BCBCBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#6C6C6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#323232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#0D0D0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-5.18277 86.7034) rotate(-123.49) scale(11.3144 28.286)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#BCBCBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#6C6C6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#323232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#0D0D0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_570_195",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(-7.21928 86.2614) rotate(-123.49) scale(8.4796 21.199)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#BCBCBC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#6C6C6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#323232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#0D0D0D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_570_195"
}, /*#__PURE__*/React.createElement("rect", {
  width: 114.8,
  height: 121.49,
  fill: "white",
  transform: "translate(0.5 0.5)"
})));

const SvgTennis = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 122,
    viewBox: "0 0 116 122",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_195)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M66.19 104.86C93.34 104.99 115.33 108.93 115.3 113.66C115.28 118.39 93.25 122.12 66.1 121.98C38.95 121.85 16.96 117.91 16.98 113.18C17 108.45 39.03 104.73 66.18 104.86H66.19Z",
    fill: "url(#paint0_radial_570_195)"
  }), _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M57.17 113.84C88.468 113.84 113.84 88.468 113.84 57.17C113.84 25.872 88.468 0.5 57.17 0.5C25.872 0.5 0.5 25.872 0.5 57.17C0.5 88.468 25.872 113.84 57.17 113.84Z",
    fill: "url(#paint3_radial_570_195)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M26.18 14.0401C40.62 3.11013 56.49 0.600131 61.67 8.38013C66.81 16.2101 59.29 31.4001 44.86 42.3201C30.45 53.2401 14.59 55.7401 9.41999 47.9301C4.24999 40.1201 11.76 24.9401 26.18 14.0401Z",
    fill: "url(#paint4_radial_570_195)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M26 14.0501C37.29 5.50011 49.71 3.54011 53.76 9.63011C57.78 15.7501 51.9 27.6401 40.62 36.1701C29.35 44.7101 16.95 46.6701 12.9 40.5601C8.86005 34.4501 14.73 22.5801 26.01 14.0501H26Z",
    fill: "url(#paint5_radial_570_195)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.45,
    d: "M25.82 16.16C34.28 9.75004 43.59 8.28004 46.63 12.85C49.64 17.44 45.24 26.34 36.78 32.74C28.33 39.14 19.04 40.61 16 36.03C12.97 31.45 17.37 22.55 25.82 16.16Z",
    fill: "url(#paint6_radial_570_195)"
  }))), _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTennis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tennis.59370ce1.svg";
export { ForwardRef as ReactComponent };